/** @format */

import React from "react";

function Fixer({ c, setC, bc, setBc }) {
  const changeBox = (status, h, s, b) => {
    let d = [...c];
    let cb = [...bc];
    b.map((i) => {
      cb[i] = status ? 1 : 0;
    });
    d[h] = status ? s : 0;
    setC(d);
    setBc(cb);
  };

  return (
    <ul>
      <li>
        <p className='head_line'>Sug‘orish ishlariga olingan suv miqdori</p>

        <ul>
          <li>
            <p>
              <input
                id='ch1'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 1, 2, [0, 1])}
                checked={c[1] == 0 ? false : true}
              />

              <label htmlFor='ch1'>1.04-8.04.23 y. mln.m3</label>
            </p>
          </li>

          <li>
            <p>
              <input
                id='ch2'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 2, 2, [2, 3])}
                checked={c[2] == 0 ? false : true}
              />

              <label htmlFor='ch2'>
                Kunlik suv sarfi m<sup>3</sup>/s.
              </label>
            </p>
          </li>
        </ul>
      </li>

      <li>
        <p className='head_line'>Sug‘orilgan maydon, ming ga</p>
        <ul>
          <li>
            <p>
              <input
                id='ch3'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 3, 2, [4, 5])}
                checked={c[3] == 0 ? false : true}
              />
              <label htmlFor='ch3'>Jami sug‘orish ishlari</label>
            </p>
          </li>

          <li>
            <p className='head_line'>Shundan</p>
            <ul>
              <li>
                <p className='head_line'>G‘alla sug‘orish</p>
                <ul>
                  <li>
                    <p>
                      <input
                        id='ch4'
                        type='checkbox'
                        onChange={(e) => changeBox(e.target.checked, 4, 1, [6])}
                        checked={c[4] == 0 ? false : true}
                      />
                      <label htmlFor='ch4'>Reja</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch5'
                        type='checkbox'
                        onChange={(e) => changeBox(e.target.checked, 5, 1, [7])}
                        checked={c[5] == 0 ? false : true}
                      />
                      <label htmlFor='ch5'>1 kunda</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch6'
                        type='checkbox'
                        onChange={(e) => changeBox(e.target.checked, 6, 1, [8])}
                        checked={c[6] == 0 ? false : true}
                      />
                      <label htmlFor='ch6'>1.04.25 dan boshlab</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch7'
                        type='checkbox'
                        onChange={(e) => changeBox(e.target.checked, 7, 1, [9])}
                        checked={c[7] == 0 ? false : true}
                      />
                      <label htmlFor='ch7'>Baxorgi sug'orish</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch8'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 8, 1, [10])
                        }
                        checked={c[8] == 0 ? false : true}
                      />
                      <label htmlFor='ch8'>Jami ekilgandan boshlab</label>
                    </p>
                  </li>

                  <li>
                    <p className='head_line'>Shu jumladan</p>
                    <ul>
                      <li>
                        <p>
                          <input
                            id='ch9'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 9, 2, [11, 12])
                            }
                            checked={c[9] == 0 ? false : true}
                          />
                          <label htmlFor='ch9'>1-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch10'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 10, 2, [13, 14])
                            }
                            checked={c[10] == 0 ? false : true}
                          />
                          <label htmlFor='ch10'>2-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch11'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 11, 2, [15, 16])
                            }
                            checked={c[11] == 0 ? false : true}
                          />
                          <label htmlFor='ch11'>3-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch12'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 12, 2, [17, 18])
                            }
                            checked={c[12] == 0 ? false : true}
                          />
                          <label htmlFor='ch12'>4-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch13'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 13, 2, [19, 20])
                            }
                            checked={c[13] == 0 ? false : true}
                          />
                          <label htmlFor='ch13'>5-suv</label>
                        </p>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li>
                <p>
                  <input
                    id='ch14'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 14, 3, [21, 22, 23])
                    }
                    checked={c[14] == 0 ? false : true}
                  />
                  <label htmlFor='ch14'>Baxorgi sho'r yuvish</label>
                </p>
              </li>

              <li>
                <p>
                  <input
                    id='ch15'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 15, 3, [24, 25, 26])
                    }
                    checked={c[15] == 0 ? false : true}
                  />
                  <label htmlFor='ch15'>
                    G'ozaga Pushti va nam suvi berish ishlari
                  </label>
                </p>
              </li>

              <li>
                <p>
                  <input
                    id='ch16'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 16, 2, [27, 28])
                    }
                    checked={c[16] == 0 ? false : true}
                  />
                  <label htmlFor='ch16'>Chigit suvi</label>
                </p>
              </li>

              <li>
                <p className='head_line'>G‘o‘za sug‘orish</p>
                <ul>
                  <li>
                    <p>
                      <input
                        id='ch17'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 17, 1, [29])
                        }
                        checked={c[17] == 0 ? false : true}
                      />
                      <label htmlFor='ch17'>Reja</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch18'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 18, 1, [30])
                        }
                        checked={c[18] == 0 ? false : true}
                      />
                      <label htmlFor='ch18'>1 kunda</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch19'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 19, 1, [31])
                        }
                        checked={c[19] == 0 ? false : true}
                      />
                      <label htmlFor='ch19'>Jami</label>
                    </p>
                  </li>

                  <li>
                    <p className='head_line'>Shundan</p>
                    <ul>
                      <li>
                        <p>
                          <input
                            id='ch20'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 20, 2, [32, 33])
                            }
                            checked={c[20] == 0 ? false : true}
                          />
                          <label htmlFor='ch20'>1-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch21'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 21, 2, [34, 35])
                            }
                            checked={c[21] == 0 ? false : true}
                          />
                          <label htmlFor='ch21'>2-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch22'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 22, 2, [36, 37])
                            }
                            checked={c[22] == 0 ? false : true}
                          />
                          <label htmlFor='ch22'>3-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch23'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 23, 2, [38, 39])
                            }
                            checked={c[23] == 0 ? false : true}
                          />
                          <label htmlFor='ch23'>4-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch24'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 24, 2, [40, 41])
                            }
                            checked={c[24] == 0 ? false : true}
                          />
                          <label htmlFor='ch24'>5-suv</label>
                        </p>
                      </li>

                      <li>
                        <p>
                          <input
                            id='ch25'
                            type='checkbox'
                            onChange={(e) =>
                              changeBox(e.target.checked, 25, 2, [42, 43])
                            }
                            checked={c[25] == 0 ? false : true}
                          />
                          <label htmlFor='ch25'>6-suv</label>
                        </p>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li>
                <p>
                  <input
                    id='ch26'
                    type='checkbox'
                    onChange={(e) =>
                      changeBox(e.target.checked, 26, 2, [44, 45])
                    }
                    checked={c[26] == 0 ? false : true}
                  />
                  <label htmlFor='ch26'>Takroriy ekin sug‘orish</label>
                </p>
              </li>
            </ul>
          </li>

          <li>
            <p>
              <input
                id='ch27'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 27, 2, [46, 47])}
                checked={c[27] == 0 ? false : true}
              />
              <label htmlFor='ch27'>
                2026-yil xosili uchun G'alla ekishdan oldingi sho'r yuvish va
                nam
              </label>
            </p>

            <p>
              <input
                id='ch28'
                type='checkbox'
                onChange={(e) => changeBox(e.target.checked, 28, 2, [48, 49])}
                checked={c[28] == 0 ? false : true}
              />
              <label htmlFor='ch28'>
                2026-yil xosili uchun G'alla sug'orish
              </label>
            </p>

            <ul>
              <li>
                <p className='head_line'>Shu jumladan</p>

                <ul>
                  <li>
                    <p>
                      <input
                        id='ch29'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 29, 2, [50, 51])
                        }
                        checked={c[29] == 0 ? false : true}
                      />

                      <label htmlFor='ch29'>Ochiq maydon</label>
                    </p>
                  </li>

                  <li>
                    <p>
                      <input
                        id='ch30'
                        type='checkbox'
                        onChange={(e) =>
                          changeBox(e.target.checked, 30, 2, [52, 53])
                        }
                        checked={c[30] == 0 ? false : true}
                      />
                      <label htmlFor='ch30'>G‘o‘za qator orasi</label>
                    </p>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <li>
        <p>
          <input
            id='ch31'
            type='checkbox'
            onChange={(e) => changeBox(e.target.checked, 31, 2, [54, 55])}
            checked={c[31] == 0 ? false : true}
          />

          <label htmlFor='ch31'>Tomorqa va boshqa sug'orish ishlari</label>
        </p>
      </li>

      <li>
        <p>
          <input
            id='ch32'
            type='checkbox'
            onChange={(e) => changeBox(e.target.checked, 32, 1, [56])}
            checked={c[32] == 0 ? false : true}
          />

          <label htmlFor='ch32'>
            1 kunda olingan suv bilan sug'orish mumkin bo'lgan maydon, ming ga
          </label>
        </p>
      </li>

      <li>
        <p>
          <input
            id='ch33'
            type='checkbox'
            onChange={(e) => changeBox(e.target.checked, 33, 1, [57])}
            checked={c[33] == 0 ? false : true}
          />

          <label htmlFor='ch33'>SFK</label>
        </p>
      </li>

      <li>
        <p>
          <input
            id='ch34'
            type='checkbox'
            onChange={(e) => changeBox(e.target.checked, 34, 1, [58])}
            checked={c[34] == 0 ? false : true}
          />

          <label htmlFor='ch34'>
            Sug‘orish ishlarida qatnashgan suvchilar soni
          </label>
        </p>
      </li>
    </ul>
  );
}

export default Fixer;
